export default __webpack_public_path__ + "static/media/startupRealCase1-en.669a06a2.jpg";